import React, { createContext, useState, useEffect } from "react";
import axios from "axios";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [role, setRole] = useState(null); // "client" | "driver" | null

  const API = process.env.REACT_APP_API_URL || "http://localhost:5002";

  const checkAuth = async () => {
    const token = localStorage.getItem("token");
    const savedRole = localStorage.getItem("userType"); // tu l’enregistres au login/signup

    if (!token) {
      setIsAuthenticated(false);
      setUserInfo(null);
      setRole(null);
      return;
    }

    try {
      // ✅ si tu as un endpoint unique qui valide tout le monde
      const res = await axios.get(`${API}/api/auth/checkAuth`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setIsAuthenticated(true);

      // ✅ on accepte plusieurs formats de réponse
      const user = res.data?.user || res.data?.chauffeur || res.data?.client || null;
      setUserInfo(user);

      // ✅ role : priorité à la réponse backend, sinon localStorage
      const backendRole = res.data?.role || user?.role || null;
      setRole(backendRole || savedRole || null);
    } catch (e) {
      localStorage.removeItem("token");
      setIsAuthenticated(false);
      setUserInfo(null);
      setRole(null);
    }
  };

  useEffect(() => {
    checkAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ✅ à appeler après login/signup
  const login = (token, user, userRole) => {
  if (token) localStorage.setItem("token", token);

  setIsAuthenticated(true);
  setUserInfo(user || null);

  if (userRole) {
    setRole(userRole);
    localStorage.setItem("userType", userRole);
  }
};

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userType");
    setIsAuthenticated(false);
    setUserInfo(null);
    setRole(null);
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        userInfo,
        role,
        checkAuth,
        login,
        logout,
        setIsAuthenticated,
        setUserInfo,
        setRole,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};